module.exports = __webpack_public_path__ + "img/35_18.694fba67.png";